import React from "react";
import { Route } from "react-router-dom";
import authenticated from "components/authenticated";
//containers
import Auth from "components/auth";
import AuthForgotPassword from "components/auth/forgot-password";
import AuthResetPassword from "components/auth/reset-password";
import AuthLogin from "components/auth/login";
import Dashboard from "components/dashboard";
import DashboardMain from "components/dashboard/main";
import Company from "components/dashboard/company";
import EditClient from "components/dashboard/company/client"
import NewCompany from "components/dashboard/company/new";
import Challenge from "components/dashboard/challenge";
import ChallengeDetail from "components/dashboard/challenge/detail";
import NewChallenge from "components/dashboard/challenge/new";
import QuestionnaireInfo from "components/dashboard/challenge/questionnaire-info";
import ChallengeAdminPage from "components/dashboard/challenge/admin"
import Student from "components/dashboard/student";
import StudentDetail from "components/dashboard/student/detail";

const RouteWithLayout = ({ layout, component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props =>
        React.createElement(
          layout,
          props,
          React.createElement(component, props)
        )
      }
    />
  );
};

export const router = (
  <div>
    <RouteWithLayout layout={Auth} exact component={AuthLogin} path="/" />
    <RouteWithLayout
      layout={Auth}
      exact
      component={AuthForgotPassword}
      path="/forgot-password"
    />
    <RouteWithLayout
      layout={Auth}
      exact
      component={AuthResetPassword}
      path="/reset-password"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(DashboardMain)}
      path="/dashboard"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(Challenge)}
      path="/challenges"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(NewChallenge)}
      path="/challenge/new"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(ChallengeDetail)}
      path="/challenges/:id"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(NewChallenge)}
      path="/challenges/edit/:id"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(QuestionnaireInfo)}
      path="/challenges/info/:id"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(ChallengeAdminPage)}
      path="/challenges/admin/:id"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(Company)}
      path="/companies"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(NewCompany)}
      path="/companies/new"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(NewCompany)}
      path="/companies/edit/:id"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(EditClient)}
      path="/companies/client/edit/:id"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(Student)}
      path="/students"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(StudentDetail)}
      path="/students/:id"
    />
    <RouteWithLayout
      layout={Dashboard}
      exact
      component={authenticated(StudentDetail)}
      path="/students/edit/:id"
    />
  </div>
);

export default router;



// WEBPACK FOOTER //
// ./src/routes.js